<template>
  <div>
    <ValidationObserver ref="observer">
      <vx-card class="form-padding">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link to="/inventory/voucher-pins" class="vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("setup.label.CreateVoucherPin") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="vx-row">
          <div
            class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full mb-3 mt-3"
          >
            <div class="vx-row">
              <div class="vx-col w-full lg:w-1/4 md:w-1/4 sm:w-full xs:w-full">
                <input
                  id="Voucher"
                  type="radio"
                  value="VOUCHER"
                  v-model="voucher.batchType"
                />
                <label for="Voucher"> {{ $t("setup.label.Voucher") }}</label>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <input
                  id="Coupon"
                  type="radio"
                  value="COUPON"
                  v-model="voucher.batchType"
                />
                <label for="Coupon"> {{ $t("setup.label.Coupon") }}</label>
              </div>
            </div>
          </div>
          <div
            class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
          ></div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.BatchName')"
            >
              <vs-input
                :label="$t('setup.label.BatchName')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="voucher.batchName"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("customers.label.BusinessEntity")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('customers.label.BusinessEntity')"
              >
                <v-select
                  label="name"
                  v-model="voucher.officeId"
                  :options="voucherTemplate.offices"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(obj) => obj.id"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.name }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.LengthOfPins')"
            >
              <vs-input
                :label="$t('setup.label.LengthOfPins')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="voucher.length"
                type="number"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.BeginWith')"
            >
              <vs-input
                :label="$t('setup.label.BeginWith')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="voucher.beginWith"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div style="height: 20px"></div>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.PinCategory") }}
                <span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.PinCategory')"
              >
                <v-select
                  label="value"
                  v-model="voucher.pinCategory"
                  :options="voucherTemplate.pinCategoryData"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(obj) => obj.value"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.value }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.Quantity')"
            >
              <vs-input
                :label="$t('setup.label.Quantity')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="voucher.quantity"
                type="number"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.SerialNoLength')"
            >
              <vs-input
                :label="$t('setup.label.SerialNoLength')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="voucher.serialNo"
                type="number"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.PinType")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.PinType')"
              >
                <v-select
                  label="value"
                  v-model="voucher.pinType"
                  :options="['VALUE', 'PRODUCT']"
                  @input="valueOptions(voucher.pinType)"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.value }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.ExpiryDate")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.ExpiryDate')"
              >
                <datepicker
                  :placeholder="$t('placeholder.label.SelectDate')"
                  v-model="voucher.expiryDate"
                  class="mb-2 font-semibold"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <div
              class="dropdown-with-label"
              v-if="!products && voucher.pinType"
            >
              <small class="date-label"
                >{{ $t("setup.label.Value")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Value')"
              >
                <v-select
                  label="mCodeValue"
                  v-model="pinValue"
                  :options="pinValues"
                  :clearable="false"
                  @input="setMCodeId(pinValue)"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(obj) => obj"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{
                    option.mCodeValue
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="dropdown-with-label" v-if="products && voucher.pinType">
              <small class="date-label"
                >{{ $t("setup.label.Product")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Product')"
              >
                <v-select
                  label="label"
                  v-model="productVal"
                  :options="productsItem"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(obj) => obj.value"
                  @input="setProductVal(productVal)"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.label }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </vx-card>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("setup.label.Reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="validateForm"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <div class="centerx">
      <vs-popup
        class="warning-msg popup-close"
        classContent="popup-example"
        :title="null"
        :active.sync="warningPopup"
        ><div
          style="font-size: 20px; color: rgb(255, 204, 0); margin-left: 10px"
          v-if="warningText"
        >
          ⚠ Warning!!
        </div>
        <div
          style="font-size: 20px; color: orangered; margin-left: 10px"
          v-if="errorMessage"
        >
          ⛔ Error!!
        </div>

        <div class="font-semibold p-3">
          {{ warningText }}
          {{ errorMessage }}
        </div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import { mapState } from "vuex";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const voucherEmptyObj = {
  batchName: "",
  batchType: "",
  officeId: "",
  beginWith: "",
  pinCategory: "",
  quantity: "",
  serialNo: "",
  pinValue: "",
  mCodeId: null,
  pinType: "",
  dateFormat: "dd MMMM yyyy",
  locale: "en",
  expiryDate: "",
};

export default {
  data() {
    return {
      voucher: { ...voucherEmptyObj },
      warningPopup: false,
      products: false,
      pinValues: [],
      pinValue: {},
      productVal: {},
      warningText: "",
      errors: [],
      productsItem: [],
    };
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      voucherTemplate: (state) => state.voucherPin.voucherFormTemplate,
      voucherProducts: (state) => state.voucherPin.voucherProducts,
      postResponse: (state) => state.voucherPin.createVoucher,
      errorMessage: (state) => state.voucherPin.formError,
    }),
  },
  methods: {
    setMCodeId(obj) {
      this.voucher.pinValue = obj.mCodeValue;
      this.voucher.mCodeId = obj.id;
    },
    setProductVal(obj) {
      this.voucher.pinValue = obj.planId;
      this.voucher.priceId = obj.priceId;
    },
    valueOptions() {
      let val = this.voucher.pinType;
      this.voucher.pinValue = "";
      if (val === "VALUE") {
        this.products = false;
        this.pinValues = this.voucherTemplate.valueCodeValueDatas;
      } else if (val === "PRODUCT") {
        this.pinValues = this.voucherProducts;
        this.products = true;
      }
    },
    async validateForm() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      // if (
      //   !this.voucher.batchName ||
      //   !this.voucher.batchType ||
      //   !this.voucher.officeId ||
      //   !this.voucher.pinCategory ||
      //   !this.voucher.beginWith ||
      //   !this.voucher.quantity ||
      //   !this.voucher.serialNo
      // ) {
      //   this.warningPopup = true;
      //   this.warningText = "Fill the required fields!";
      // }
      this.warningText = "";
      this.createvoucher();
    },
    async createvoucher() {
      this.voucher.expiryDate = moment(this.voucher.expiryDate).format(
        "DD MMMM YYYY"
      );
      await this.$store.dispatch("voucherPin/setPostvoucher", this.voucher);
      if (this.postResponse) {
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Voucher Pin Created Successfully!",
          type: "success",
        });
        this.resetForm();
        this.$router.push(`/inventory/voucher-pins`);
      }
      if (this.errorMessage) {
        this.warningPopup = true;
      }
    },
    async callFormTemplate() {
      this.$store.dispatch("voucherPin/setVoucherFormTemplate");
      await this.$store.dispatch("voucherPin/setVoucherProduct");
      this.products = [];
      for (let tempPlan of this.voucherProducts) {
        if (tempPlan.pricingData.length > 0) {
          if (tempPlan.isPrepaid != "N") {
            let planName = tempPlan.planCode;
            let planId = tempPlan.planId;
            for (let tempPrice of tempPlan.pricingData) {
              this.productsItem = [
                ...this.productsItem,
                {
                  label:
                    planName +
                    " " +
                    tempPrice.billingFrequency +
                    " " +
                    tempPrice.price,
                  value: { planId: planId, priceId: tempPrice.id },
                },
              ];
            }
          }
        }
      }
    },
    resetForm() {
      this.voucher = { ...voucherEmptyObj };
      this.voucher.batchName = "";
      this.voucher.batchType = "";
      this.voucher.beginWith = "";
      this.voucher.officeId = "";
      this.voucher.pinCategory = "";
      this.voucher.serialNo = "";
      this.voucher.expiryDate = "";
      this.voucher.quantity = "";
      this.voucher.pinType = "";
    },
    cancel() {
      this.$router.push("/inventory/voucher-pins");
    },
  },
  watch: {},
  mounted() {
    this.resetForm();
    this.callFormTemplate();
  },
};
</script>
<style></style>
